<template lang="pug">
  b-modal#unbindOTPModal(
    ref="unbindOTPModal"
    :title="$t('ui.combine.unbind_otp_2fa')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
    @hide="reset"
  )
    b-form(novalidate :disabled="loading" @submit.stop.prevent="submit")
      .form-group
        label {{ $t("ui.otp") }}
        DebounceInput(
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          ref="unbind_2fa_code"
          :dirty="$v.unbind_2fa_code.$dirty"
          :error="$v.unbind_2fa_code.$error"
          :placeholder='$t("ui.enter_6_digit_code")'
          v-model.trim.lazy="$v.unbind_2fa_code.$model"
          :maxLength="6"
          :disabled="loading"
          class="otp-input-field"
        )
        ValidateResult(:value="$v.unbind_2fa_code" :name="$t('ui.otp')")
      .form-group
        b-alert.alert-sm.animated.flash(:show="!feedback.success" variant="danger") {{ $t(feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.submit')" isModal=true)
</template>

<script>
import { required, numeric, minLength, maxLength } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      unbind_2fa_code: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    unbind_2fa_code: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  },
  methods: {
    done(event) {
      event.preventDefault();
      this.submit();
    },
    reset() {
      this.unbind_2fa_code = "";
      this.feedback.success = true;
      this.feedback.status = "";
      this.$v.unbind_2fa_code.$reset();
    },
    shown() {
      this.$nextTick(() => {
        if (this.$refs.unbind_2fa_code) {
          this.$refs.unbind_2fa_code.$el.focus();
        }
      });
    },
    async submit() {
      this.$v.unbind_2fa_code.$touch();
      
      if (this.$v.unbind_2fa_code.$invalid) {
        return;
      }
      
      this.loading = true;
      this.feedback.success = true;
      this.feedback.status = "";
      
      try {
        const response = await this.$store.dispatch("user/unbindOTP2fa", {
          code: this.unbind_2fa_code
        });

        if (response.success) {
          this.$refs.unbindOTPModal.hide();
          this.$swal({
            title: this.$t("ui.success"),
            text: this.$t("message.otp_unbind_success"),
            type: "success",
            allowOutsideClick: false
          }).then(() => {
            this.$emit("unbind-success");
          });
        } else {
          this.feedback.success = false;
          this.feedback.status = response.status ? this.$t("error." + (response.status)) : this.$t("message.otp_unbind_failed");
        }
      } catch (error) {
        this.feedback.success = false;
        this.feedback.status = error.status ? this.$t("error." + (error.status)) : this.$t("message.otp_unbind_failed");
        // this.feedback.status = this.$t("message.otp_unbind_failed");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.otp-input-field {
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.5rem;
  font-weight: bold;
  padding: 12px;
  min-width: 200px;
  flex: 1;
}

.otp-input-field::placeholder {
  font-size: 1.5rem;
  letter-spacing: 0.1rem;
  opacity: 0.6;
}
</style>

